import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { RequestService } from '../request.service';

@Injectable()
export class FailedEmailService {

  constructor(
    protected requestService: RequestService,
  ) {}

  get(criteria ?) :Promise<any> {

    let requestData = {
      urlKey: 'failedEmail'
    }

    if(!_.isEmpty(criteria)) {
      requestData["urlQueryParams"] = criteria;
    }

    return this.requestService.makeRequest(requestData)
      .then((response: any) => response.json());
  }

  sendFailedEmail(data) :Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'sendFailedEmail',
      method: 'post',
      body: JSON.stringify(data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/failedEmails/failed-email.service.ts